export default [
  { url: "/home", text: "Home" },
  { url: "/startDrawing", text: "Start Drawing!" },
  { url: "/about", text: "About & How to Play" },
  { url: "/contact", text: "Contact" }
];
